'use client';

import { useState } from 'react';
import { initials } from './format';

// Solid fills only: translucent colours double-darken where avatars overlap.
const FILLS = ['#1c2b39', '#2f4a63', '#3d6b4f', '#6b4f3d', '#4a3d6b', '#3d5f6b'];

function fillFor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  // The modulus is inside the list by construction; FILLS is never empty.
  return FILLS[h % FILLS.length] as string;
}

export function Avatar({
  name,
  imageUrl = null,
  size = 32,
}: {
  name: string;
  imageUrl?: string | null;
  size?: number;
}) {
  const [broken, setBroken] = useState(false);
  const showImage = imageUrl && !broken;
  return (
    <span
      title={name}
      className="box-border inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full align-middle leading-none font-bold text-white ring-2 ring-white"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.36),
        background: showImage ? '#e5e7eb' : fillFor(name),
      }}
    >
      {showImage ? (
        <img
          src={imageUrl}
          alt=""
          width={size}
          height={size}
          className="h-full w-full object-cover"
          loading="lazy"
          draggable={false}
          onError={() => setBroken(true)}
        />
      ) : (
        initials(name)
      )}
    </span>
  );
}

/** Overlapping avatars for a group's leaders. */
export function AvatarStack({
  people,
  size = 32,
  max = 3,
}: {
  people: { name: string; imageUrl?: string | null }[];
  size?: number;
  max?: number;
}) {
  return (
    <span className="inline-flex shrink-0 items-center leading-none">
      {people.slice(0, max).map((p, i) => (
        <span
          key={p.name + i}
          className="inline-flex shrink-0"
          style={{ marginLeft: i === 0 ? 0 : -Math.round(size * 0.3), width: size, height: size }}
        >
          <Avatar name={p.name} imageUrl={p.imageUrl} size={size} />
        </span>
      ))}
    </span>
  );
}
